import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exchange-alt" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]


export default /*#__PURE__*/_defineComponent({
  emits: ['switch-pair'],
  setup(__props, { emit }) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "p-1 px-3 transition-colors transform bg-yellow-300 hover:bg-yellow-400 text-gray-900 text-lg rounded-lg",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('switch-pair')))
  }, _hoisted_2))
}
}

})